<template>
  <joy-page :joyPageStatus="joyPageStatus">
    <div class="detail setHeightFullGrey paddingbottom50">
      <div class="whatWeDoDescItem">
        <img
          style="width:100%;object-fit: cover;height: 100%;"
          :src="listData.face?'http://img.jiarixiaodui.com/'+listData.face:yanxuebg"
        >
        <div class="mengBan">
          <div class="paddingXs">
            <van-row
              type="flex"
              class="paddingTopBottomXm"
              style="color: white;font-size: 16px;font-weight: 600;padding: 5px 0;"
            >
              <van-col>
                {{listData.title}}
              </van-col>
            </van-row>
            <van-row
              type="flex"
              class="paddingTopBottomXm"
              style=""
              v-show="listData.height_price!='0' && listData.height_price!=''"
            >
              <van-col>
                <span style="font-size: 16px;color: #fbbd08;">{{listData.height_price || 100}}</span>
                <span style="font-size: 12px;color: #fbbd08;">元/天</span>
              </van-col>
            </van-row>
            <van-row
              type="flex"
              class="paddingTopBottomXm"
              style="color: white;font-size: 14px;"
            >
              <van-col span="6">
                <van-icon
                  style="line-height: 20px;margin-right: 2px;"
                  name="location-o"
                ></van-icon>
                <span style="line-height: 20px">{{listData.site}}</span>
              </van-col>
              <van-col span="8">
                <van-icon
                  style="line-height: 20px;margin-right: 2px;"
                  name="eye-o"
                ></van-icon>
                <span style="line-height: 20px">{{listData.view_num}}</span>
              </van-col>
            </van-row>
          </div>
        </div>
      </div>

      <div
        class="setWhite marginBottomXm"
        v-for="(item, index) in sets"
        :key="index"
        style="margin-bottom: 10px;"
      >
        <div class="paddingXm">
          <div class="">
            <span class="text-df text-gray marginRightXm">✦营期:</span>
            <span class="text-df text-black">{{item.title}}</span>
          </div>
          <div class="">
            <span class="text-df text-gray marginRightXm">✦时间:</span>
            <span class="text-df text-black">{{ item.start_time }}至{{ item.end_time }}</span>
          </div>
        </div>
        <template v-if="!item.disabled">
          <div
            class=""
            v-for="(radios, indexSon) in item.jobs"
            :key="indexSon"
          >
            <van-cell
              @click="checkboxChange(radios.id)"
              center
              size="mini"
              :border="false"
              :title="radios.name"
              v-if="radios.status===1"
            >
              <van-icon
                slot="right-icon"
                :name="checkboxSelected"
                style="line-height: inherit;"
              />
            </van-cell>
            <van-cell
              @click="checkboxChange(radios.id)"
              center
              size="mini"
              :border="false"
              :title="radios.name"
              v-else-if="radios.status == 0"
            >
              <van-icon
                slot="right-icon"
                :name="checkboxUnSelected"
                style="line-height: inherit;"
              />
            </van-cell>
          </div>
        </template>
        <template v-else>
          <div
            class=""
            v-for="(radios, indexSon) in item.jobs"
            :key="indexSon"
          >
            <van-cell
              center
              size="mini"
              :border="false"
              :title="radios.name"
              v-if="radios.status===1"
            >
              <van-icon
                slot="right-icon"
                :name="checkboxSelected"
                style="line-height: inherit;"
              />
            </van-cell>
            <van-cell
              center
              size="mini"
              :border="false"
              :title="radios.name"
              v-else-if="radios.status == 0"
            >
              <van-icon
                slot="right-icon"
                :name="checkboxDisabled"
                style="line-height: inherit;"
              />
            </van-cell>
          </div>
        </template>
      </div>
      <div class="setWhite ">
        <div class="paddingXm">
          <div class="text-gray text-lg">工作要求</div>
          <div
            v-if="listData.require"
            class="text-black text-df paddingXm"
            v-html="listData.require"
          >
          </div>
          <div
            v-else
            class="text-black text-df paddingXm"
          >
            暂无信息
          </div>
        </div>
      </div>

      <div
        v-show="listData.desc"
        class="setWhite marginTopXm"
      >
        <div class="paddingXm">
          <div class="text-gray text-lg">活动内容</div>
          <div
            class="contentPartyIndex text-black text-df paddingXm"
            v-html="listData.desc"
          ></div>
        </div>
      </div>

      <!-- 底部按钮 -->
      <van-goods-action class="fixBottom">
        <van-goods-action-icon
          icon="wap-home-o"
          text="首页"
          to="/"
        />
        <van-goods-action-icon @click="like">
          <van-icon
            slot="icon"
            :color="likeThis?'red':'#595C68'"
            :name="likeThis?'like':'like-o'"
          ></van-icon>
          <span slot="default">{{likeThis?'已收藏':'收藏'}}</span>
        </van-goods-action-icon>
        <van-goods-action-icon
          icon="chat-o"
          text="客服"
          @click="goService"
        />
        <van-goods-action-icon
          icon="share"
          text="分享"
          @click="showShare"
        />
        <van-goods-action-button
          type="danger"
          text="报名"
          @click="signUp"
        />
      </van-goods-action>

      <Share ref="share"></Share>
    </div>
  </joy-page>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  components: {},
  created(e) {
    this.loadData()
  },
  computed: {
    ...mapState(['token', 'site']),
    ...mapGetters(['hasLogin']),
  },
  data() {
    return {
      yanxuebg:
        'http://img.jiarixiaodui.com/jrhb/web_img/photo.jpg?x-oss-process=image/resize,m_fill,h_320,w_600',
      joyPageStatus: '',
      sets: '',
      require: '',
      listData: '',
      desc: '',
      checkboxSelected: this.$mAssetsPath.checkboxSelected,
      checkboxUnSelected: this.$mAssetsPath.checkboxUnSelected,
      checkboxDisabled: this.$mAssetsPath.checkboxDisabled,
      items: [],
      likeThis: false,
      submit: [],
    }
  },
  methods: {
    signUp() {
      if (!this.checkLogin()) {
        return false
      }
      const that = this
      that.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner',
        message: '报名中',
      })
      let arrayResult = []
      for (let i in that.sets) {
        if (!that.sets[i].disabled) {
          let set_ids = that.sets[i].id
          let job_id = []
          for (let j in that.sets[i].jobs) {
            if (that.sets[i].jobs[j].status == 1) {
              job_id.push(that.sets[i].jobs[j].id)
            }
          }
          arrayResult.push({ set_id: set_ids, job_id: job_id })
        }
      }
      if (arrayResult.length == 0) {
        that.$toast.fail('暂无有效场次以供您报名')
        return false
      }
      try {
        let query = {
          job_ids: arrayResult,
        }
        that.$axios.put('/apply/update', query).then((res) => {
          if (res.data.code == 200) {
            that.$toast.clear()
            setTimeout(function () {
              that.$toast.success('报名成功')
              // that.$router.replace({path: '/application'});
            }, 500)
          } else {
            that.$toast.clear()
            setTimeout(function () {
              // that.$toast.success(res.data.msg);
              that.$toast.fail(res.data.msg)
            }, 500)
          }
        })
      } catch (e) {
        if (this.$mConfig.debug) {
          console.log(e)
        }
      }
    },
    goService() {
      try {
        this.$axios.get('connect/service?site=' + this.site).then((res) => {
          if (res.data.code == 200) {
            console.log(res.data.data[0].mobile)
            window.location.href = 'tel://' + res.data.data[0].mobile
          }
        })
      } catch (e) {
        if (this.$mConfig.debug) {
          console.log(e)
        }
      }
    },
    loadFavor() {
      try {
        this.$axios
          .get('favor/myfavor?party_id=' + this.listData.id)
          .then((res) => {
            res.data.code == 200
              ? (this.likeThis = true)
              : (this.likeThis = false)
          })
      } catch (e) {
        if (this.$mConfig.debug) {
          console.log(e)
        }
      }
    },
    like() {
      try {
        this.$axios
          .post('favor/favorupdate', { party_id: this.listData.id })
          .then((res) => {
            if (res.data.code == 200) {
              this.likeThis = !this.likeThis
              this.$toast(res.data.msg)
            }
          })
      } catch (e) {
        if (this.$mConfig.debug) {
          console.log(e)
        }
      }
    },
    showShare() {
      this.$refs.share.show()
    },
    checkboxChange(radios) {
      if (!this.checkLogin()) {
        return
      }
      const that = this

      for (let i in that.sets) {
        for (let j in that.sets[i].jobs) {
          if (that.sets[i].jobs[j].id == radios) {
            if (!that.sets[i].jobs[j].checked) {
              that.sets[i].jobs[j].checked = true
              that.sets[i].jobs[j].status = 1
            } else {
              that.sets[i].jobs[j].checked = false
              that.sets[i].jobs[j].status = 0
            }
          }
        }
      }
    },
    loadData() {
      let id = this.$route.query.id
      const that = this
      this.joyPageStatus = 'loading'
      try {
        this.$axios
          .get('party/view', {
            params: {
              id: id,
            },
          })
          .then((res) => {
            let data = res.data.data
            if (res.data.code == 200) {
              this.joyPageStatus = 'success'

              if (data.party.deleted == 0) {
                data.party.require = data.party.require.replace(/\n/g, '<br/>')
                data.party.desc = data.party.desc.replace(/\n/g, '<br/>')
                //  data.party.require= data.party.require.replace(/\s+|&nbsp;/ig, '<br/>')
                this.listData = data.party
                if (!localStorage.site || !this.$store.state.site) {
                  this.$store.commit('ChangeSite', this.listData.site)
                }
                let config = {
                  title: this.listData.title,
                  img: this.listData.face
                    ? 'http://img.jiarixiaodui.com/' + this.listData.face
                    : this.yanxuebg,
                  sharePath: '/pages/detail/detail?id=' + this.listData.id,
                }
                this.wxShare(config)
                let sets = data.sets
                for (let i in sets) {
                  for (let j in sets[i].jobs) {
                    if (sets[i].jobs[j].status == 0) {
                      sets[i].jobs[j].checked = false
                    } else {
                      sets[i].jobs[j].checked = true
                    }
                  }
                }
                this.sets = sets

                if (this.token) {
                  this.loadFavor()
                }
              } else {
                this.$dialog
                  .confirm({
                    title: '提示',
                    message: '本活动已被删除',
                    showCancelButton: false,
                  })
                  .then(() => {
                    that.$router.go(-1)
                  })
              }
            }
          })
      } catch (e) {
        if (this.$mConfig.debug) {
          console.log(e)
        }
      }
    },
  },
}
</script>
<style>
.contentPartyIndex {
  background: #fff;
  padding-left: 10px;
  padding-right: 10px;
}
.contentPartyIndex * {
  max-width: 100% !important;
}
</style>
<style scoped="scoped">
@import url('../../colorui/main.css');
.whatWeDoDescItem {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  position: relative;
  height: 140px;
}
.mengBan {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}
.radioChoice {
  width: 20px;
  height: 20px;
}
</style>
